import { render, staticRenderFns } from "./set-sec-password.vue?vue&type=template&id=1be1a40a&scoped=true&"
import script from "./set-sec-password.vue?vue&type=script&lang=js&"
export * from "./set-sec-password.vue?vue&type=script&lang=js&"
import style0 from "./set-sec-password.vue?vue&type=style&index=0&id=1be1a40a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be1a40a",
  null
  
)

export default component.exports